<template>
  <div class="ras-vacation ras-page">
    <div class="ras-page__back">
      <button @click="$router.go(-1)"><SVGArrowLeft /> Back</button>
    </div>
    <div class="ras-page__header">
      <h1 class="ras-page__question">What type of vacation are you looking for?</h1>
      <p class="ras-page__info">Select 1 type</p>
    </div>
    <form class="ras-page__form" @submit.prevent="nextStep">
      <div class="radio-wrapper">
        <RadioButton :selected="checked" :options="options" v-model="form.typeOfHoliday"></RadioButton>
      </div>
      <div class="button-wrapper">
        <button :class="['ras-button', {'ras-button--disabled': !formValid}]">Next Step</button>
      </div>
    </form>
  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue'
import SVGArrowLeft from '@/assets/svgs/arrow-left.svg?inline'
export default {
  name: 'Vacation',
  components: {
    RadioButton,
    SVGArrowLeft
  },
  data: () => ({
    options: [
      'Adventure Holiday',
      'Couples Holiday',
      'Beach Holiday',
      'City Break',
      'Remote'
    ],
    form: {
      typeOfHoliday: '',
    },
    checked: '',
    formValid: false,
  }),
  methods: {
    nextStep() {
      if(this.formValid) {
        this.$store.dispatch('setFormData', this.form).then(() => {
          this.$router.push({ path: 'season' })
        })
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.formValid = this.form.typeOfHoliday !== ''
      },
      deep: true
    }
  },
  mounted() {
    if(this.$store.getters.getFormByKey('typeOfHoliday').length) {
      this.checked = this.$store.getters.getFormByKey('typeOfHoliday')
      this.form.typeOfHoliday = this.$store.getters.getFormByKey('typeOfHoliday')
    }
    else {
      this.form.typeOfHoliday = ''
    }
  }
}
</script>